import { useWorkspaceWindowType } from './use-workspace-window-type';

/**
 * Several call sites read `usePanelsPermittedInWindow()` to mean "this is a full workspace window"
 * — render the footer, mount the messaging processor, show the panel buttons. That happened to be
 * equivalent while `MAP_V2.panelsPermitted` was false, but the map window is gaining camera panels
 * (RND-73560 flips the flag), so the two questions have to be asked separately.
 *
 * Pair this with `usePanelsPermittedInWindow()` at those sites rather than replacing it.
 */
export function useIsMapWindow(): boolean {
    return useWorkspaceWindowType() === 'MAP_V2';
}
